import { EmailOutlined, LocationOn, MessageSharp, MoreHoriz, PhoneRounded } from "@mui/icons-material"
import { Button, Card, CardMedia, Grid, IconButton, ImageListItemBar, Typography } from "@mui/material"
import { useEffect, useRef, useState } from "react"
import { Helmet } from "react-helmet"
import { useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import { get_all_packages_list } from "../../../actions/packages_actions"
import { send_email_emailJs } from "../../../actions/shared_actions"
import { ABOUT_ROUTE, CONTACT_ROUTE, PACKAGES_ROUTE } from "../../../routing/routing_constants"
import { COMPANY_CONTACT, COMPANY_LOCATION, COMPANY_NAME, TAG_LINE } from "../../../settings/constants"
import { LargeCards, LargeCardsFlip, ServicesSection } from "./front_page"

import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import PropTypes from 'prop-types'
import * as React from 'react'

import { ourServices } from "./constants"
import './home_style.css'
import './styles.css'
// import {App} from "./landing_v2/App"

// export const HomeVersion2 = () => {
//     return <App />
// }

export const Home = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [packages_list, setPackagesList] = useState([])
    const [load, set_load] = useState(false)

    useEffect(()=>{
        set_load(true)
        get_all_packages_list(1)
            .then(res => setPackagesList(res?.results))
            .finally(e=>set_load(false))
    },[])

    // open dialog box
	const [open, setOpen] = useState(false);
	const [selected, setSelected] = useState({"title":""})

    const handleClose = () => {
        setOpen(false);
    };

    const handleSubmitInquiry = (e, inquiry) => {
        inquiry = {...inquiry, message:inquiry.message + `; PACKAGE: ${selected.title}; ID: ${selected.id}`}
        e.preventDefault()
        dispatch(send_email_emailJs(inquiry))
        setOpen(false)
    }

    return(
        <div>
            <div className="landing_images landing_center" id="site_cover_image">
                <Helmet>
                    <title>DGA | Home</title>
                    <meta 
                        name="DGA Tours and Travel Homepage"
                        description="DGA Tours and Travel offers tours and travel services, including plane, train and bus tickets bookings, pick ups and drop offs from airports and train stations, Vacations bookings and planning, day tours and hikes, and many more"
                    />
                </Helmet>
                <div className="company_details">
                    <div className="company_name" id="company_name">
                        {COMPANY_NAME}
                    </div>
                    <div className="tag_line">
                        {TAG_LINE}
                    </div>
                </div>
                <div className="navigation_on_home_container">
                </div> 
            </div>
            <div className="middle_component">
                <div className="searchhomecontainer">
                    {/* <div className="promo_texts">
                        <LandingElements />
                    </div> */}
                    <FadeInSection>
                        <div className="top_destinations">
                            <div className="">
                                {/* <div className="flexrow flex_row_wrap"> */}
                                    <div style={{width:'100%', minHeight:'max-content', display:'flex', flexDirection:'column', paddingBottom:'1em', textAlign:'left'}}>
                                        <Card class='wider_end_services'>
                                                <h4>{'TOP DESTINATIONS'}</h4>
                                        </Card>
                                        <div className="paper">
                                            <MediaComponent
                                            loading={load} 
                                            data={packages_list} 
                                            handleClose={handleClose} 
                                            open={open}
                                            handleSubmit={handleSubmitInquiry} 
                                            />
                                        </div>
                                    <div className="search_complete_home" style={{marginTop:'30px'}}>
                                        <div>
                                            <div>
                                                <Button variant="contained" color="warning" onClick={e=>navigate(PACKAGES_ROUTE)}>EXPLORE PACKAGES AND DESTINATIONS</Button>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                            </div>
                        </div>
                    </FadeInSection>
                    {/* <div>
                        <LandingElements />
                    </div> */}
                    <FadeInSection>
                        <div className="why_us">
                            <ServicesSection services={ourServices} />
                        </div>
                    </FadeInSection>
                    <FadeInSection>
                        <div className="why_us">
                        <div style={{width:'100%', height:'max-content', display:'flex', flexDirection:'column'}}>
                            <FadeInSection>
                                <Card class='wider_end_services'>
                                    <h4>{'WHY CHOOSE US'}</h4>
                                </Card>
                            </FadeInSection>
                                <div className="flexed why_us_reasons">
                                    <FadeInSection>
                                        <div className="why_reason">
                                            <img src="https://toppng.com/uploads/preview/50-px-holiday-icon-11553476348zwxogmazqs.png" loading="lazy" alt=""/>
                                            <p> Customer Focused</p>
                                            <p>Our all time aim is to satisfy the customer by all means. Our services are customer-centered. Get your calls and queries replied to in less than 1 hour, at any day and time</p>
                                        </div>
                                    </FadeInSection>
                                    <FadeInSection>
                                        <div className="why_reason">
                                            <img src="https://cdn-icons-png.flaticon.com/512/3168/3168862.png" loading="lazy" alt=""/>
                                            <p>Verified</p>
                                            <p>We have been verified to offer tours and travel services with the best partners in the industry. Hotels and tour destinations trust us whenever we knock</p>
                                        </div>
                                    </FadeInSection>
                                    <FadeInSection>
                                        <div className="why_reason">
                                            <img src="https://www.clipartmax.com/png/small/182-1828680_person-icons-luggage-holiday-icon-png.png" loading="lazy" alt=""/>
                                            <p>Travel-Friendly Packages</p>
                                            <p>We have a very wide range of package offers. Most of tours are custom-made to the customer as much as possible to fit their context and demands. We go the extra mile to ensure that the customer comes first.</p>
                                        </div>
                                    </FadeInSection>
                                </div>
                            </div>
                        </div>
                    </FadeInSection>
                    <FadeInSection>
                        <div className="offers_home">
                        <div style={{width:'100%', height:'max-content', display:'flex', flexDirection:'column', backGroundColor:''}}>
                            <FadeInSection>
                                <Card class='wider_end_services'>
                                    <h4>{'WHAT WE PROVIDE'}</h4>
                                </Card>
                            </FadeInSection>
                            <div className="flexed why_us_reasons">
                                <FadeInSection>
                                    <div className="why_reason">
                                        <img src="https://icon-library.com/images/transportation-icon-png/transportation-icon-png-29.jpg" loading="lazy" alt="" />
                                        <h5>Transport</h5>From pick up point to the tour destination, and back
                                    </div>
                                </FadeInSection>
                                <FadeInSection>
                                    <div  className="why_reason">
                                        <img src="https://icon2.cleanpng.com/20180204/rpw/kisspng-hotel-motel-gratis-clip-art-hotel-png-picture-5a77d69d7edec4.4346610115178031655197.jpg" loading="lazy" alt=""/>
                                        <h5>Accommodation</h5> In liason with preferred hotels, accommodation for every journey is catered for, in accordance with the package details
                                    </div>
                                </FadeInSection>
                                <FadeInSection>
                                    <div  className="why_reason">
                                        <img src="https://img.favpng.com/24/21/9/food-icon-thanksgiving-fill-icon-food-icon-png-favpng-3mbb5g1Ubhi7EHPpjELypuBpn.jpg" loading="lazy" alt="" />
                                        <h5>Meals</h5> Meals during the tour as provided in the package details
                                    </div>
                                </FadeInSection>
                                {/* <div  className="why_reason">
                                    <img src="https://www.freeiconspng.com/thumbs/photography-icon-png/photography-icon-png-15.png" alt="" />
                                    <h5>Free Photoshoot</h5> Everyone is entitled to free photoshoot(more than 100photos) during the trip. 
                                </div> */}</div>
                        </div>
                        </div> 
                    </FadeInSection>
                    <FadeInSection>                   
                        <div className="about_us_center">
                            <LargeCards title={'ABOUT US'} info={
                        <div>
                                <p>
                                Founded in 2022, {COMPANY_NAME} deals primarily but not exclusively in adventure tourism.
                            </p>
                            <p>
                                We seek to make every adventure as exciting and as individual as possible. 
                            </p>
                            <p>
                                Our main aim is to bring your adventure to life and give you an experience  of a lifetime; an adrenaline rush like no other.
                            </p>
                            <p>
                                Book and travel with us today
                            </p>
                            <div>
                                    {/* <InvisibleBtn2 value={"Learn More"} className={"cancel_btn"} onClick={()=>navigate(ABOUT_ROUTE)} /> */}
                                <Button onClick={()=>navigate(ABOUT_ROUTE)} variant='contained' size="large" color="warning" >Learn More</Button>

                                </div>
                        </div>
                        } />
                        </div>
                    </FadeInSection>
                    <FadeInSection>
                        <div className="reviews_landing">
                        <LargeCardsFlip title={'CONTACT US'} info={
                            <div className="paper">
                                <div style={{paddingBottom:'30px'}}>
                                    <div>
                                        <PhoneRounded /> 
                                    </div>
                                {COMPANY_CONTACT.phones[0]} / {COMPANY_CONTACT?.phones[1]}
                            </div>
                            <div style={{paddingBottom:'30px'}}>
                                <div>
                                    <EmailOutlined/> 
                                </div>
                                {COMPANY_CONTACT.emails[0]}
                            </div>
                            <div style={{paddingBottom:'30px'}}>
                                <div>
                                <LocationOn/> 
                                </div>
                                {COMPANY_LOCATION.office_address}
                            </div>
                            <p>
                                Or
                            </p>
                            <div>
                                {/* <InvisibleBtn2 value={"Write to us..."} className={"cancel_btn"} onClick={()=>navigate(CONTACT_ROUTE)} /> */}
                                <Button onClick={()=>navigate(CONTACT_ROUTE)} variant='contained' size="large" color="warning" >Write to us directly</Button>
                            </div>

                        </div>
                        } />
                        </div>
                    </FadeInSection>
                </div>
            </div>
        </div>
    )
} 

export function FadeInSection(props) {
	const [isVisible, setVisible] = useState(true);
	const domRef = useRef();
	// useEffect(() => {
	//   const observer = new IntersectionObserver(entries => {
	// 	entries.forEach(entry => setVisible(entry.isIntersecting));
	//   }, 
    //   { rootMargin: "-50px" }
    //   );
	//   observer.observe(domRef.current);
	//   return () => observer.disconnect();
	// }, []);

	return (
	  <div
		className={`fade-in-section ${isVisible ? 'is-visible' : ''}`}
		ref={domRef}
	  >
		{props.children}
	  </div>
	);
  }


export const PackCardHome = ({pack, enquire}) => {
    const navigate = useNavigate()

    return (
        <>
            <Card className={"card"}>
                <CardMedia className={"media"} image={pack.cover_image} title={pack.title}/>
                
                <div className={"overlay2"}>
                    <Typography variant="subtitle1"> {pack?.cost?.amount} {pack?.cost?.currency} </Typography>
                    {/* <Typography variant="body2" > </Typography> */}
                </div>
                
                <div className={"overlay"}>
                    {pack?.no_of_days && <Typography variant="subtitle2" color={'grey'} > {pack?.no_of_days} Day{pack?.no_of_days>1 &&'s'} </Typography>}
                    {pack?.no_of_nights && <Typography variant="subtitle2" color={'grey'} > {pack?.no_of_nights} Night{pack?.no_of_nights>1 && 's'} </Typography>}
                </div>
                <ImageListItemBar 
                    title={pack.title} 
                    actionIcon={
                        <div>
                            <IconButton onClick={e=>navigate(PACKAGES_ROUTE+'/'+pack.id)}>
                                <MoreHoriz color="warning" />
                            </IconButton>
                            <IconButton onClick={e=>enquire(e)}>
                                <MessageSharp color="success" />
                            </IconButton>
                        </div>
                    }
                    />
            </Card>
            </>
    )
}


export function Media(props) {
  const { loading = false, data=[]} = props;
  const navigate = useNavigate()

  return (
    <Grid container wrap="wrap" spacing={3}>
      {(loading ? Array.from(new Array(4)) : data).map((item, index) => (
        <Grid item key={index} sm={6} xs={11} lg={4} >
          {item ? (
            <CardMedia className={"media"} image={item.cover_image} loading={'lazy'} style={{cursor:'pointer'}} onClick={e=>navigate(`${PACKAGES_ROUTE + '/' + item.id}`)} />
            // <img src={item.cover_image} loading={'lazy'} style={{width:"100%" heright}} />
          ) : (
            <Skeleton variant="rectangular" width={'100%'} height={'150px'} />
          )}

          {item ? (
            <Box sx={{ pr: 2 }}>
              <Typography gutterBottom variant="body2">
                {item.title}
              </Typography>
              <Typography display="block" variant="caption" color="text.secondary">
                {item.description.slice(0,66)}{item.description.length>66? '...':''}
              </Typography>
              {/* <Typography variant="caption" color="text.secondary">
                {`• ${item.no_of_days}`}
              </Typography> */}
            </Box>
          ) : (
            <Box sx={{ pt: 0.5 }}>
              <Skeleton />
              <Skeleton width="60%" />
            </Box>
          )}
        </Grid>
      ))}
    </Grid>
  );
}

Media.propTypes = {
  loading: PropTypes.bool,
  data: PropTypes.array
};

export function MediaComponent({data, loading}) {
  return (
    <Box sx={{ overflow: 'wrap' }}>
      <Media loading={loading} data={data} />
      {/* <Media data={data} /> */}
    </Box>
  );
}
